export default "__VITE_ASSET__7b48a755__"